/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

// Data
import { ObtenerGaleria, AddGaleria, DelGaleria } from "store/galeria/galeriaActions";

import Loading from "components/loading";
import StepperImagenes from "./componentes/stepperImagenes";
import DetallesImagenes from "./componentes/detallesImagenes";
import { Button, Divider, Grid, Icon } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import ModalContent from "components/ModalContent";
import FormCargarDocumento from "./componentes/formCargarDocumento";
import { store } from "store/store";
import _ from "lodash";

function Galeria({ idSolicitud, esExpediente }) {
  const { detalleSolicitud, isloadingGaleria } = useSelector((state) => state.solicitud);
  const dispatch = useDispatch();

  //Form nueva iamgen
  const [galeriaNombre, setGaleriaNombre] = useState("");
  const [fechaFoto, setFechaFoto] = useState("");
  const [archivo, setArchivo] = useState(null);
  const [descripcion, setDescripcion] = useState("");

  const [openmodal, setopenmodal] = useState(false);
  const [openmodalDelete, setopenmodalDelete] = useState(false);
  const [galeriaEliminar, setGaleriaEliminar] = useState({});

  const refresh = () => {
    setGaleriaNombre("");
    setFechaFoto("");
    setArchivo(null);
    setDescripcion("");
    setopenmodal(false);
  };

  const save = () => {
    var data = {
      GaleriaNombre: galeriaNombre,
      IdSolicitud: idSolicitud,
      FechaFoto: fechaFoto,
      ArchivoFile: archivo,
      Descripcion: descripcion,
    };

    AddGaleria(dispatch, data);
    setopenmodal(false);
    refresh();
  };

  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  const agregardocumento = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente ? 92 : 91)
  );
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={9} lg={12}>
          <MDBox textAlign="center">
            {agregardocumento.length == 0 ? null : (
              <Button
                variant="contained"
                startIcon={<Icon>add</Icon>}
                onClick={() => {
                  setopenmodal(true);
                }}
                size="small"
                color="primary"
              >
                Agregar Documento
              </Button>
            )}
          </MDBox>
        </Grid>
      </Grid>
      <Divider />

      {isloadingGaleria ? (
        <Loading title={"Cargando galeria, por favor espere"} />
      ) : detalleSolicitud.galeria.length === 0 ? (
        <MDTypography variant="h6" color="white" sx={{ marginLeft: "15px" }}>
          NO HAY DOCUMENTOS EN LA GALERÍA
        </MDTypography>
      ) : (
        <Grid container spacing={5}>
          <Grid item xs={12} md={6}>
            <StepperImagenes></StepperImagenes>
          </Grid>
          <Grid item xs={12} md={6}>
            <DetallesImagenes
              idSolicitud={idSolicitud}
              onClickDel={(galeriaElemento) => {
                setGaleriaEliminar(galeriaElemento);
                setopenmodalDelete(true);
              }}
              esExpediente={esExpediente}
            ></DetallesImagenes>
          </Grid>
        </Grid>
      )}

      <ModalContent
        title={"Agregar Documento"}
        maxWidth="sm"
        fullWidth={true}
        open={openmodal}
        fullScreen={false}
        handleClose={refresh}
        handleAcept={save}
        textAccept="Agregar documento"
      >
        <FormCargarDocumento
          props={{
            galeriaNombre: galeriaNombre,
            fechaFoto: fechaFoto,
            archivo: archivo,
            descripcion: descripcion,
          }}
          onChangeGaleria={(value, campo) => {
            if (campo === "galeriaNombre") setGaleriaNombre(value);
            if (campo === "fechaFoto") setFechaFoto(value);
            if (campo === "archivo") setArchivo(value);
            if (campo === "descripcion") setDescripcion(value);
          }}
        />
      </ModalContent>
      <ModalContent
        title={"Eliminar documento"}
        maxWidth="sm"
        fullWidth={false}
        open={openmodalDelete}
        fullScreen={false}
        handleClose={() => {
          setopenmodalDelete(false);
          refresh();
        }}
        handleAcept={() => {
          var data = {
            idGaleria: galeriaEliminar.idGaleria,
            rutaArchivo: galeriaEliminar.rutaDescargar,
          };
          DelGaleria(dispatch, data);
          setopenmodalDelete(false);
        }}
        textAccept={"Eliminar"}
      >
        <MDBox>
          <MDTypography variant="button" color="text" fontWeight="regular">
            ¿Desea eliminar el documento <strong>{galeriaEliminar.galeriaNombre}</strong>?
          </MDTypography>
        </MDBox>
      </ModalContent>
    </>
  );
}

export default Galeria;
